export default "__VITE_ASSET__C8Jfrq$P__"